import { helper } from '@ember/component/helper';

export default helper(function notInHelper([ collection, value ]) {
  let result;
  if (!collection) {
    result = true;
  } else if (Array.isArray(collection)) {
    result = collection.indexOf(value) < 0;
  } else {
    result = !collection[value];
  }
  return result;
});
